import React from "react";

// Grid of standalone stat cards — a muted uppercase label + light-tinted
// icon badge on top, the big value below, and an optional trend/sub line
// underneath. Matches the "metric card" pattern (label+icon row, then
// value, then context) rather than the old side-by-side icon+value strip.
//
// items: [{ icon, label, value, c, sub, trend, up, onClick? }] — `c` is
// the accent colour for this card's icon badge, `sub` an optional plain
// context string (e.g. "18 claims"), and `trend`+`up` an optional signed
// change (e.g. trend="+12%", up=true) rendered with an arrow. An optional
// `onClick` makes the whole card a shortcut.
export const KpiStrip = ({ items = [] }) => (
  <div className="grid gap-3 mb-4" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(168px, 1fr))" }}>
    {items.filter(Boolean).map((s, i) => (
      <div
        key={i}
        onClick={s.onClick}
        className={`group bg-bg1 border border-b0 rounded-2xl p-4 shadow-card transition-all duration-150 hover:shadow-card-hover ${s.onClick ? "cursor-pointer" : ""}`}
      >
        <div className="flex items-center justify-between">
          <span className="text-[11px] font-semibold text-t2 uppercase tracking-wider">{s.label}</span>
          {s.icon && (
            <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-105" style={{ background: `${s.c}14`, color: s.c }}>
              <s.icon size={18} color={s.c} />
            </div>
          )}
        </div>
        <div className="mt-3">
          <div className="text-2xl font-bold text-t0 tracking-tight truncate">{s.value ?? '—'}</div>
          {(s.trend || s.sub) && (
            <div className="flex items-center gap-1.5 mt-1 text-xs">
              {s.trend && (
                <span className={`inline-flex items-center font-semibold ${s.up ? "text-g" : "text-r"}`}>
                  {s.up ? "↑" : "↓"} {s.trend}
                </span>
              )}
              {s.sub && <span className="text-t3">{s.sub}</span>}
            </div>
          )}
        </div>
      </div>
    ))}
  </div>
);
